<template>
  <ValidationObserver ref="validate">
    <div class="check-address">
      <h3 class="title1">
        {{$t('advanced.address.info')}}
        <div class="labelInexchangable lineAdjust pr-4 pb-2" style="border-bottom: 1px solid #E6EAF0;">{{ $t('advanced.address.proofOfAddress') }}</div>
      </h3>
      <!-- {{form.disabled}} -->
      <div class="input-form form" :class="{disabled: disable}">
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.building.$error"
            :error-label="getErrorLabel($v.form.building, 'building')"
          >
            <q-input
              v-model="form.building"
              @blur="$v.form.building.$touch"
              :class="{'invalid-class': $v.form.building.$error}"
              :float-label="$t('advanced.address.building')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="building"
            :model.sync="form.building"
            :label="$t('advanced.address.building')"
            :outlined="true"
            :rules="rules.building"
            :readonly="disable"
            :value="form.building"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.street.$error"
            :error-label="getErrorLabel($v.form.street, 'street')"
          >
            <q-input
              v-model="form.street"
              @blur="$v.form.street.$touch"
              :class="{'invalid-class': $v.form.street.$error}"
              :float-label="$t('advanced.address.street')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="street"
            :model.sync="form.street"
            :label="$t('advanced.address.street')"
            :outlined="true"
            :rules="rules.street"
            :readonly="disable"
            :value="form.street"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.district.$error"
            :error-label="getErrorLabel($v.form.district, 'district')"
          >
            <q-input
              v-model="form.district"
              @blur="$v.form.district.$touch"
              :class="{'invalid-class': $v.form.district.$error}"
              :float-label="$t('advanced.address.district')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="district"
            :model.sync="form.district"
            :label="$t('advanced.address.district')"
            :outlined="true"
            :rules="rules.district"
            :readonly="disable"
            :value="form.district"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.province.$error"
            :error-label="getErrorLabel($v.form.province, 'district')"
          >
            <q-input
              v-model="form.province"
              @blur="$v.form.province.$touch"
              :class="{'invalid-class': $v.form.province.$error}"
              :float-label="$t('advanced.address.province')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="province"
            :model.sync="form.province"
            :label="$t('advanced.address.province')"
            :outlined="true"
            :rules="rules.province"
            :readonly="disable"
            :value="form.province"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.zipCode.$error"
            :error-label="getErrorLabel($v.form.zipCode, 'zipCode')"
          >
            <q-input
              v-model="form.zipCode"
              @blur="$v.form.zipCode.$touch"
              :class="{'invalid-class': $v.form.zipCode.$error}"
              :float-label="$t('advanced.address.zipCode')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="zipCode"
            :model.sync="form.zipCode"
            :label="$t('advanced.address.zipCode')"
            :outlined="true"
            :rules="rules.zipCode"
            :readonly="disable"
            :value="form.zipCode"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.city.$error"
            :error-label="getErrorLabel($v.form.city, 'city')"
          >
            <q-input
              v-model="form.city"
              @blur="$v.form.city.$touch"
              :class="{'invalid-class': $v.form.city.$error}"
              :float-label="$t('advanced.address.city')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="city"
            :model.sync="form.city"
            :label="$t('advanced.address.city')"
            :outlined="true"
            :rules="rules.city"
            :readonly="disable"
            :value="form.city"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <VueCountryIntl
            v-model="form.countryCode"
            class="quasar-country-select glay-bg"
            disableCountry="Malaysia"
            model="country"
            :showAreaCode="false"
            type="country"
            @onchange="countrySelect"
            :placeholder="$t('common.selectCountry')"
            :disabled="disable"
          ></VueCountryIntl>
          <!-- <div class="color-error error-tip pt-5" style="font-size: 12px;">
            <span
              v-show="$v.form.countryCode.$error && !$v.form.countryCode.required"
            >{{this.$t('common.selectCountry')}}</span>
          </div>-->

          <div class="d-flex align-center error-msg mt-2 mb-2" style="min-height: 18px">
            <div v-if="!true">{{this.$t('common.selectCountry')}}</div>
          </div>
        </div>
        <div class="form-group">
          <div class="upload-row row">
            <div class="file-opt-area" v-if="uploaderCanInit">
              <h5
                class="upload-title"
                style="width: max-content;"
              >{{this.$t('advanced.address.authImgUrl1')}}</h5>
              <UploadImg
                :type="'UPLOAD_RESIDENT'"
                :previewImg="form.authImgUrl1Display"
                @uploadSuccess="_uploadSuccess1"
                @error="_error"
              ></UploadImg>
            </div>
          </div>
          <!-- <div class="error-tip color-error pt-30" style="font-size: 12px;">
            <span
              v-show="$v.form.authImgUrl1.$error && !$v.form.authImgUrl1.required"
            >{{this.$t('advanced.address.authImgUrl1')}}</span>
          </div>-->

          <div class="d-flex align-center error-msg mt-2 mb-2" style="min-height: 18px">
            <div v-if="!true">{{this.$t('advanced.address.authImgUrl1')}}</div>
          </div>
        </div>
        <!--<div class="btn-box">
        <q-btn
          class="no-shadow" color="primary"
          :loading="form.committing"
          :disabled="status == 0 || status == 1"
          @click="save"
          :label="$t('actions.save')"/>
        <q-btn
          class="no-shadow cancel-btn" color="standard"
          :loading="form.committing"
          :disabled="status == 0 || status == 1"
          @click="cancel"
          :label="$t('actions.cancel')"/>
        </div>-->
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import TextFieldComponent from '@/components/Form/TextField';
import UploadImg from '@/components/UploadImg/UploadImg';
import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel.js';
import { seniorCertificationApi } from '@/api/user/seniorCertification';

const numberAndWordAndSymbol = /^[0-9a-zA-Z~!@#\$%\^&\*()/\|,.<>?"'();:_\+-=\[\]{}\s]*$/;

export default {
  name: 'check-address',
  components: { UploadImg, TextFieldComponent },
  mixins: [getErrorLabelMixin],
  data() {
    return {
      form: {
        building: '',
        countryCode: '', // 国籍 86
        street: '', // 街道
        district: '', //
        zipCode: '', // 邮政编码
        city: '', // 城市
        authImgUrl1: '',
        authImgUrl1Display: '',
        committing: false,
        disabled: true
      },
      disable: false,
      // 判断上传插件是否需要初始化，因为用户提交过资料后会立即跳转至详情页，因此这里需要做个判断
      uploaderCanInit: true,
      rules: {
        countryCode: {
          required: true
        },
        building: {
          regex: numberAndWordAndSymbol
        },
        street: {
          required: true,
          regex: numberAndWordAndSymbol
        },
        district: {
          required: true,
          regex: numberAndWordAndSymbol
        },
        zipCode: {
          required: true,
          regex: numberAndWordAndSymbol
        },
        city: {
          required: true,
          regex: numberAndWordAndSymbol
        },
        province: {
          required: false
        },
        authImgUrl1: {
          required: true
        }
      }
    };
  },
  props: {
    data /* resident */: {
      type: Object,
      required: true
    },
    status: {
      type: Number,
      required: true
    }
  },
  watch: {
    data: function(value) {
      this.form = value;
    },
    status: function(value) {
      this.disable = value == 0 /* pending approve */ || value == 1; /* approved */
    }
  },
  created() {},
  mounted() {
    this.disable = this.status == 0;
  },
  destroyed() {},
  methods: {
    // 国籍select事件
    countrySelect(option) {
      this.form.countryName = option.name;
    },
    _uploadSuccess1(file, res) {
      this.form.authImgUrl1 = res.filename;
      this.form.authImgUrl1Dsp = res.readCredential;
    },
    // 图片类型选择错误回调
    _error(errCode) {
      // Q_TYPE_DENIED: 上传文件类型不正确
      // F_EXCEED_SIZE: 上传的文件体积大于设定的体积
      if (errCode === 'F_EXCEED_SIZE') {
        this.$q.notify({
          color: 'negative',
          message: '上传的图片不能大于5M！',
          icon: 'warning',
          position: 'top',
          type: 'warning'
        });
      } else if (errCode === 'Q_TYPE_DENIED') {
        this.$q.notify({
          color: 'negative',
          message: '只能上传.jpg、.jpeg、.bmp、.png格式的图片',
          icon: 'warning',
          position: 'top',
          type: 'warning'
        });
      }
    },
    async save() {
      const validated = await this.$refs.validate.validate();
      if (!validated || this.committing) {
        return;
      }

      let data = this.form;
      data.countryCode = data.countryCode.toUpperCase();
      this.committing = true;
      return seniorCertificationApi
        .setAdvanceCertificationResident(data)
        .then(res => {
          this.successNotify(this.$t('advanced.address.successSave'));
          this.committing = false;
          return true;
        })
        .catch(error => {
          return false;
        });
    },
    cancel() {}
  }
};
</script>

<style lang="stylus" scoped>
@import 'index.styl';

.labelInexchangable {
  font-size: 13px;
}

.title1 {
  font-size: 16px;
  color: #333;
  height: 102px;
  line-height: 50px;

  .lineAdjust {
    line-height: 20px;
  }
}
</style>
